import range from 'lodash-es/range'

import { Skeleton } from '../../../Skeleton'
import { BirdviewChartType } from '../../DashboardBirdview.constants.charts'

import {
  BIRDVIEW_CHART_CARD_SKELETON_BARS_COUNT,
  BIRDVIEW_CHART_CARD_SKELETON_COLUMNS_COUNT,
  BIRDVIEW_CHART_CARD_SKELETON_LEGEND_COUNT,
} from './BirdviewChartCardSkeleton.constants'

import * as styles from './BirdviewChartCardSkeleton.module.css'

export function getBirdviewChartCardSkeletonContent(type) {
  switch (type) {
    case BirdviewChartType.Aging:
      return (
        <div className={styles.columns}>
          {range(BIRDVIEW_CHART_CARD_SKELETON_COLUMNS_COUNT).map(index => (
            <Skeleton className={styles.column} key={index} />
          ))}
        </div>
      )
    case BirdviewChartType.Bars:
      return (
        <div className={styles.bars}>
          {range(BIRDVIEW_CHART_CARD_SKELETON_BARS_COUNT).map(index => (
            <div className={styles.barRow} key={index}>
              <Skeleton className={styles.barLabel} />
              <Skeleton className={styles.bar} />
            </div>
          ))}
        </div>
      )
    case BirdviewChartType.Donut:
      return (
        <div className={styles.donut}>
          <Skeleton className={styles.ring} />
          <div className={styles.legend}>
            {range(BIRDVIEW_CHART_CARD_SKELETON_LEGEND_COUNT).map(index => (
              <Skeleton className={styles.legendItem} key={index} />
            ))}
          </div>
        </div>
      )
    case BirdviewChartType.Line:
      return <Skeleton className={styles.area} />
    default:
      return null
  }
}
